import { useParams } from 'react-router-dom'

import { DatasetDetailsOperationBar, PageContainer } from '@/components'
import { config } from '@/config'
import { useCurrentUser } from '@/hooks'

import { WholesaleMarketDetailsContent } from './components'
import {
  useMarketParticipationFilters,
  useWholesaleDataset,
  useWholesaleMarketDatasetNames
} from './hooks'

export const WholesaleMarketDetailsPage = () => {
  const { id } = useParams()
  const allDatasetNames = useWholesaleMarketDatasetNames()
  const { isUser } = useCurrentUser()
  const {
    datasetInfo,
    isFetching,
    archiveDataset,
    unArchiveDataset,
    removeDataset,
    lockDataset,
    cloneDataset,
    isCloneDatasetInProgress
  } = useWholesaleDataset(+(id || ''))

  const { filters, treeSelectItems, isDatasetValid } =
    useMarketParticipationFilters(datasetInfo)

  const isDatasetDisabled =
    !isUser ||
    datasetInfo?.isLocked ||
    datasetInfo?.isDefault ||
    datasetInfo?.isArchive ||
    false

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { title: 'Library' },
            {
              title: 'Wholesale Market',
              path: config.links.library.wholesaleMarket
            },
            { title: datasetInfo?.name || '' }
          ]}
        />
      }
      menuBar={
        !datasetInfo ? null : (
          <DatasetDetailsOperationBar
            datasetInfo={datasetInfo}
            onArchiveDataset={archiveDataset}
            onUnArchiveDataset={unArchiveDataset}
            onLockDataset={lockDataset}
            onRemoveDataset={removeDataset}
            onCloneDataset={(datasetName, onSuccess) =>
              cloneDataset(datasetName, { onSuccess })
            }
            isCloneDatasetInProgress={isCloneDatasetInProgress}
            allDatasetNames={allDatasetNames}
            isLockDisabled={!isDatasetValid}
          />
        )
      }>
      <WholesaleMarketDetailsContent
        filters={filters}
        datasetInfo={datasetInfo}
        isDatasetDisabled={isDatasetDisabled}
        treeSelectItems={treeSelectItems}
      />
    </PageContainer>
  )
}
